var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "#011936",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34137 10.3496C2.9212 10.3496 0 10.8841 0 13.0205C0 15.1585 2.90263 15.7114 6.34137 15.7114C9.76154 15.7114 12.6827 15.1769 12.6827 13.0406C12.6827 10.9025 9.78011 10.3496 6.34137 10.3496Z",
    fill: "#014971"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34157 8.31461C8.67093 8.31461 10.5376 6.46516 10.5376 4.15731C10.5376 1.84946 8.67093 0 6.34157 0C4.01305 0 2.14551 1.84946 2.14551 4.15731C2.14551 6.46516 4.01305 8.31461 6.34157 8.31461Z",
    fill: "#014971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.5eeb17ae340fd4e9df15dd9cece4b6a8.svg";
export { ForwardRef as ReactComponent };